<template>
  <section style="width: 100%">
    <h1>Categories</h1>
    <div class="my-3">
      <v-layout row wrap>
        <v-flex xs6 fluid align-center justify-center>

          <!-- START EDIT MODAL -->
          <v-dialog persistent v-model="modalWindow" max-width="500px">
            <v-btn color="primary" dark slot="activator" v-if="isWriteAvailable" class="mb-2">Add Item</v-btn>
            <v-card>
              <v-card-media v-if="editedItem.image" :src="editedItem.image" height="200px"/>
              <v-card-title>
                <span class="headline">{{ formTitle }} </span>
              </v-card-title>
              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12>
                      <content-field
                        label="Name"
                        v-model="editedItem.name"
                        @input="$v.editedItem.name.$touch()"
                        @blur="$v.editedItem.name.$touch()"
                        :error="$v.editedItem.name"
                      ></content-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-layout row wrap>
                        <v-flex xs12 d-flex class="my-4">
                          <v-select
                            :items="verticalList"
                            v-model="editedItem.vertical"
                            label="Select vertical"
                          />
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12>
                      <v-radio-group v-model="editedItem.categoryType">
                        <v-radio
                          v-for="categoryType in categoryTypeList"
                          :key="categoryType"
                          :label="`Type: ${categoryType}`"
                          :value="categoryType"
                        ></v-radio>
                      </v-radio-group>
                    </v-flex>
                    <v-flex xs12>
                      <h3>Packages list: </h3>
                      <v-layout row wrap>
                        <v-flex xs12 d-flex class="my-4">
                          <v-select
                            :items="filteredPackages"
                            v-model="editedItem.packages"
                            item-text="name"
                            item-value="id"
                            label="Select packages"
                            multiple
                            :key="editedItem.id"
                          />
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12>
                      <v-card>
                        <content-editor
                          label="Description"
                          v-model="editedItem.description"
                          @input="$v.editedItem.description.$touch()"
                          @blur="$v.editedItem.description.$touch()"
                          :error="$v.editedItem.description"
                        />
                      </v-card>
                    </v-flex>
                    <small v-if="showRequiredMessage">*indicates required field</small>
                    <v-flex xs12>
                      <content-field
                        label="Badge display name"
                        v-model="editedItem.badgeDisplayName"
                        @blur="$v.editedItem.badgeDisplayName.$touch()"
                        :error="$v.editedItem.badgeDisplayName"
                      />
                    </v-flex>
                    <v-flex xs12 d-flex align-center justify-start>
                      <e-color-picker
                        label="Badge color"
                        @colorChange="onColorChange($event)"
                        v-model="editedItem.badgeColor"
                      />
                      <div class="red--text" v-if="isBadgeColorInvalid">Please select color</div>
                    </v-flex>
                    <v-flex xs12>
                      <v-btn color="success" @click="modalGallery=!modalGallery">Choose Image</v-btn>
                      <v-btn :disabled="!editedItem.image" color="success" @click="editedItem.image = ''">Remove Image</v-btn>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>

              <v-card-text>
                <v-container>
                  <v-flex d-flex xs12
                  v-for="(cat, index) in editedItem.subCategories"
                  :key="index">
                    <content-field
                      label="Sub category"
                      :value="cat"
                      v-model="editedItem.subCategories[index]"
                    ></content-field>
                    <v-btn color="blue darken-1" flat @click.stop="deleteSubCategory(index)">Delete</v-btn>
                  </v-flex>
                  <v-btn color="blue darken-1" flat @click.stop="addSubCategory()">Add sub category</v-btn>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer/>
                <v-btn color="blue darken-1" flat @click.stop="close">Cancel</v-btn>
                <v-btn color="blue darken-1" flat @click.stop="save">Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- END EDIT MODAL -->

          <v-btn color="primary" @click="reset">Reset</v-btn>

          <v-dialog v-model="modalGallery">
            <galleries-list :modalView="true" @pickedImage="setImage"/>
          </v-dialog>

        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs2>
          <v-text-field
            append-icon="search"
            label="Search by name"
            v-model="search.filterByName"
          ></v-text-field>
        </v-flex>
        <v-flex xs2 offset-xs1>
          <v-text-field
            append-icon="search"
            label="Search by ID"
            v-model="search.filterById"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-data-table
        class="elevation-1"
        :headers="headers"
        :items="categoriesList"
        :pagination.sync="pagination"
        :total-items="totalItemsInTable"
        :loading="loading"
        :disable-initial-sort="true"
      >
        <template slot="items" slot-scope="props">
          <td class="py-4">
            <v-avatar><img :src="(props.item.image) || 'http://via.placeholder.com/350x200.jpg'" alt="no image">
            </v-avatar>
          </td>
          <td class="py-4">{{ props.item.name }}</td>
          <td class="py-4">{{ props.item.vertical }}</td>
          <td class="py-4" v-html="props.item.description"></td>
          <td class="py-4">{{ props.item.badgeDisplayName }}</td>
          <td class="py-4 text-xs-center">
            <div
              class="selected-color-box"
              :style="{background: props.item.badgeColor}"
            />
          </td>
          <td class="py-4 text-xs-center">
            <v-checkbox
               v-model="props.item.showAccountManagerEmail"
               @change="editCategory(props.item)"
            />
          </td>
          <td class="py-4 text-xs-center">
            <v-checkbox
               v-model="props.item.hasDynamicName"
               @change="editCategory(props.item)"
            />
          </td>
          <td class="py-4 text-xs-center">
            <v-switch
              :disabled="!isWriteAvailable"
              v-model="props.item.type"
              @change="editCategory(props.item)"
              true-value="Buy"
              false-value="Sell"
              :label="props.item.type.toString()"
            />
          </td>
          <td class="py-4 text-xs-center">
            <v-switch
              :disabled="!isWriteAvailable"
              v-model="props.item.status"
              @change="editCategory(props.item)"
              true-value="Enabled"
              false-value="Disabled"
              :label="props.item.status.toString()"
            />
          </td>
          <td class="text-xs-center">
            <v-tooltip bottom>
              <v-btn color="lime"
                :disabled="!isWriteAvailable"
                fab flat
                slot="activator"
                @click.stop="editItem(props.item)"
              >
                <v-icon>create</v-icon>
              </v-btn>
              <span>Edit</span>
            </v-tooltip>
          </td>
          <!-- <td class="text-xs-center">
            <v-tooltip bottom>
              <v-btn
                color="error"
                :disabled="!isWriteAvailable"
                fab flat
                slot="activator"
                @click.stop="deleteCategory(props.item)"
              >
                <v-icon>delete</v-icon>
              </v-btn>
              <span>Delete</span>
            </v-tooltip>
          </td> -->
        </template>
      </v-data-table>
    </div>
  </section>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import { timeSettings } from '@/modules/settings/'
  import debounce from 'lodash.debounce'
  import { equals, not, pathOr, path, clone } from 'ramda'
  import { required } from 'vuelidate/lib/validators'
  import GalleriesList from '@/components/pages/Gallery/GalleriesList'
  import mixins from '@/utils/mixins'
  import EColorPicker from '@/components/shared/EColorPicker'

  export default {
    name: 'CategoryPage',
    mixins: [mixins.isWriteAvailable],
    components: { GalleriesList, EColorPicker },
    data () {
      return {
        headers: [
          { text: 'Image', value: 'image', search: false, sortable: false, width: 100 },
          { text: 'Name', value: 'name', search: true, sortable: true, width: 400 },
          { text: 'Vertical', value: 'vertical', search: false, sortable: false, width: 400 },
          { text: 'Description', value: 'description', search: true, sortable: true },
          { text: 'Badge display name', value: 'badgeDisplayName', search: false, sortable: false, width: 150},
          { text: 'Badge color', value: 'badgeColor', search: false, sortable: false, width: 100},
          { text: 'Show manager account email', search: false, sortable: false, align: 'center', width: 150 },
          { text: 'Dynamic category name', search: false, sortable: false, align: 'center', width: 150 },
          { text: 'Type', search: false, sortable: false, align: 'center', width: 150 },
          { text: 'Status', search: false, sortable: false, align: 'center', width: 150 },
          { text: 'Edit', search: false, sortable: false, align: 'center', width: 50 }
          // { text: 'Delete', search: false, sortable: false, align: 'center', width: 50 }
        ],
        allPackages: [],
        filteredPackages: [],
        categoryTypeList: ['CryptoTrader', 'None'],
        verticalList: ['None', 'General', 'Online trading', 'Digital assets', 'Payments', 'Fintech'],
        loading: true,
        search: {
          filterByName: '',
          filterById: ''
        },
        pagination: {
          rowsPerPage: 10
        },
        selected: [],
        showFilter: false,
        modalWindow: false,
        modalGallery: false,
        editedIndex: -1,
        editedItem: {
          name: '',
          vertical: '',
          description: '',
          image: '',
          type: 'Buy',
          badgeColor: '',
          badgeDisplayName: '',
          hasDynamicName: false,
          showAccountManagerEmail: false,
          packages: [],
          subCategories: []
        },
        defaultItem: {
          name: '',
          description: '',
          image: '',
          type: '',
          badgeColor: '',
          badgeDisplayName: '',
          hasDynamicName: false,
          showAccountManagerEmail: false,
          packages: [],
          subCategories: []
        },
        showRequiredMessage: false,
        // DON'T DELETE! need for isWriteAvailable mixin
        scopeForWrite: 'master'
      }
    },
    computed: {
      ...mapGetters([
        'isLoggedIn',
        'categoriesList',
        'totalCategoriesPages',
        'totalCategoriesItems',
        'packagesList'
      ]),
      formTitle () {
        return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
      },
      totalItemsInTable () {
        return this.totalCategoriesItems || (this.totalCategoriesPages * this.pagination.rowsPerPage)
      },
      isBadgeColorInvalid () {
        return this.$v.editedItem.badgeColor.$dirty && this.$v.editedItem.badgeColor.$invalid
      },
      needToFilterPackages () {
        return path(['id'], this.editedItem) + path(['categoryType'], this.editedItem)
      }
    },
    watch: {
      needToFilterPackages: {
        handler (newVal) {
          this.filterPackages()
        },
        immediate: true,
        deep: true
      },
      packagesList: {
        handler (newVal) {
          this.allPackages = clone(newVal)
        },
        immediate: true
      },
      modalWindow (val) {
        if (!val) this.close()
      },
      pagination: {
        handler (newVal, oldVal) {
          const checkOnlyTotalItemsChanged = () => {
            const isDescendingEqual = newVal.descending === oldVal.descending
            const isPageEqual = newVal.page === oldVal.page
            const isRowsPerPageEqual = newVal.rowsPerPage === oldVal.rowsPerPage
            const isSortByEqual = newVal.sortBy === oldVal.sortBy
            return isDescendingEqual && isPageEqual && isRowsPerPageEqual && isSortByEqual
          }
          if (not(checkOnlyTotalItemsChanged())) {
            this.getCategories()
          }
        },
        deep: true
      },
      search: {
        handler () {
          this.getCategories()
        },
        deep: true
      }
    },
    methods: {
      ...mapActions([
        'addCategoryList',
        'getCategoriesList',
        'editCategoryList',
        'deleteCategoryList',
        'showResultErrorMessage',
        'getPackagesList'
      ]),
      filterPackages () {
        this.filteredPackages = this.allPackages.filter((packageItem) => {
          return packageItem.visibility === 'Category'
        })
        if (path(['categoryType'], this.editedItem) === 'CryptoTrader') {
          this.filteredPackages = this.filteredPackages.filter((packageItem) => {
            return packageItem.type === 'Free'
          })
        }
      },
      addSubCategory () {
        if ( this.editedItem.subCategories === null) this.editedItem.subCategories = []
        this.editedItem.subCategories.push('')
      },
      deleteSubCategory (index) {
        this.editedItem.subCategories.splice(index, 1)
      },
      editItem (item) {
        this.editedIndex = this.categoriesList.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.editedItem.badgeColor = {
          hex: item.badgeColor
        }
        this.modalWindow = true
      },
      close () {
        this.$v.editedItem.$reset()
        this.showRequiredMessage = false
        this.modalWindow = false
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      },
      async save () {
        if (this.$v.editedItem.$invalid) {
          this.$v.editedItem.$touch()
          return false
        }
        try {
          if (path(['categoryType'], this.editedItem) === 'CryptoTrader') {
            this.editedItem.packages = this.editedItem.packages.filter((packageId)=>{
              let packageItem = this.allPackages.find((packageItem)=> {
                return packageItem.id === packageId
              })
              return packageItem.type === 'Free'
            })
          }
          if (this.editedIndex > -1) {
            await this.editCategory(this.editedItem)
          } else {
            await this.addCategory(this.editedItem)
          }
          this.close()
        }catch (err) {
          throw err
        }
      },
      onColorChange (color) {
        this.editedItem.badgeColor = color
      },
      reset () {
        this.search.filterByName = ''
        this.search.filterById = ''
        this.showFilter = false
      },
      getCategories: debounce(async function () {
        this.loading = true
        const { sortBy, descending, page, rowsPerPage } = this.pagination
        let itemsOnPage = equals(rowsPerPage, -1) ? this.totalCategoriesItems : rowsPerPage
        const sort = descending ? 'Desc' : 'Asc'
        const name = sortBy ? sortBy[0].toUpperCase() + sortBy.slice(1) : null
        const newPage = page - 1
        const pageCheck = newPage > 0 ? newPage : 0
        const getParams = {
          page: pageCheck,
          itemsOnPage,
          filter: {},
          sort,
          name
        }
        const categoryName = this.search.filterByName
        if (categoryName) {
          getParams.filter.categoryName = categoryName
        }
        const categoryId = this.search.filterById
        if (categoryId) {
          getParams.filter.id = categoryId
        }
        await this.getCategoriesList(getParams)
        this.loading = false
      }, timeSettings.delayTime),
      async addCategory (item) {
        const test = {}
        try {
          const payload = { ...item }
          payload.badgeColor = pathOr(null, ['badgeColor', 'hex'], payload)
          await this.addCategoryList(payload)
          await this.getCategories()
          this.close()
        } catch (err) {
          throw err
        }
      },
      async editCategory (item) {
        try {
          const payload = { ...item }
          payload.badgeColor = pathOr(null, ['badgeColor', 'hex'], payload)
          await this.editCategoryList(payload)
          await this.getCategories()
          this.close()
        } catch (err) {
          throw err
        }
      },
      async deleteCategory (item) {
        try {
          await this.deleteCategoryList(item.id)
          await this.getCategories()
        } catch (err) {
          this.showResultErrorMessage(err)
        }
      },
      setImage (item) {
        this.editedItem.image = item.imagesUrls.originalImageUrl
        this.modalGallery = false
      },
      async receiveRequeiredData () {
        await this.getCategories()
        await this.getPackagesList()
      }
    },
    validations () {
      return {
        editedItem: {
          name: { required },
          description: { required },
          badgeColor: { required },
          badgeDisplayName: { required }
        }
      }
    },
    mounted () {
      this.receiveRequeiredData()
    },
  }
</script>

<style type="scss">
  .arrow {
    margin: 0 -10px;
  }

  .arrow i {
    font-size: 16px;
  }

  .selected-color-box {
    display: inline-block;
    width: 27px;
    height: 27px;
    margin-left: 10px;
    border-radius: 2px;
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/Categories/index.vue